import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { EllipsisIcon, SearchIcon, QuestionMarkIcon } from "../../../components/Svg";
import { ModalTypes, Urls } from "../../../constants";
import { AiTab, AiTabs } from '../../../components/AiTabs';
import UIState, { selectMobileLayout } from '../../../store/UIState';
import Ai, {
  selectAllCustomTemplates,
  selectAllstandardTemplates,
  selectStanndardTempTags,
  selectTotalCustomTempPage,
  selectTotalTempPage
} from '../../../store/models/Ai';
import { selectCurrentProjectId } from '../../../store/models/Project';
import { Pagination } from '../../../components/Pagination';
import classNames from 'classnames';
import { useLocation } from "react-router";
import { getQueryParams, mergeUrl } from "../../../utils/url";
import { replaceTo } from "../../../store/history";
import ApiKeyNote from '../../../components/ApiKeyNote';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import Tooltip from "../../../components/Tooltip";


const DateOptions = {
  month: 'short',
  day: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true
};

function ModelExplorerPage() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { templateId } = getQueryParams(location.search);
  const history = useHistory();
  const projectId = useSelector(state => selectCurrentProjectId(state));
  const standardTemplates = useSelector(state => selectAllstandardTemplates(state));
  const customTemplates = useSelector(state => selectAllCustomTemplates(state, projectId));
  const totalTempPages = useSelector(state => selectTotalTempPage(state));
  const totalCustomTempPages = useSelector(state => selectTotalCustomTempPage(state));
  const isMobile = useSelector(state => selectMobileLayout(state));
  const tags = useSelector(state => selectStanndardTempTags(state));

  const [selectedTab, setSelectedTab] = useState('create-from-template')
  const [activePopup, setActivePopup] = useState(-1);
  const [crtTmpPage, setCrtTmpPage] = useState(1);
  const [crtCtmTmpPage, setCrtCtmTmpPage] = useState(1);
  const [selectedTags, setSelectedTags] = useState([]);
  const filterRef = useRef();

  useEffect(() => {
    if (templateId && !_.isEmpty(standardTemplates)) {
      replaceTo(Urls.AI_DEDICATED_MODELS, { projectId: projectId ?? 'service' })
      dispatch(UIState.actions.showModal(ModalTypes.CREATE_DEPLOYMENT, { modalId: templateId }))
    }
  }, [templateId, standardTemplates]);

  useEffect(() => {
    (async () => {
      try {
        await fetchTemplateWithFilter();
      } catch (e) {

      }
    })();
  }, [selectedTags])


  const fetchTemplateWithFilter = async () => {
    if (crtTmpPage !== 1) setCrtTmpPage(1);
    const filter = filterRef.current.value;
    if (!filter && selectedTags.length === 0) {
      await dispatch(Ai.actions.fetchstandardTemplates());
      return;
    }
    await dispatch(Ai.actions.fetchTemplatesWithFilter(selectedTags, filter))
  }

  const handleOpenModel = (modalId) => {
    dispatch(UIState.actions.showModal(ModalTypes.CREATE_DEPLOYMENT, { modalId }))
  }

  const handleOpenCustom = () => {
    dispatch(UIState.actions.showModal(ModalTypes.CREATE_CUSTOM_TEMPLATE))
  }

  const handlePopup = (event, i) => {
    event.stopPropagation();

    if (i === -1) {
      setActivePopup(i)
      return;
    }
    setActivePopup(v => {
      if (v === i) return -1;
      return i;
    })
  }

  const handleEdit = (event, template) => {
    event.stopPropagation();
    setActivePopup(-1);
    dispatch(UIState.actions.showModal(ModalTypes.CREATE_CUSTOM_TEMPLATE, { type: 'update', template: template }))
  }

  const handleDelete = (event, template) => {
    event.stopPropagation();
    setActivePopup(-1);
    const onConfirm = async () => {
      await dispatch(Ai.actions.deleteCustomTemplate(template.id, projectId));
      await dispatch(Ai.actions.fetchCustomTemplates(projectId, 1, 8));
    }
    dispatch(UIState.actions.showModal(ModalTypes.DELETE, { title: template.name, onConfirm }))
  }

  const handleDuplicate = (event, template) => {
    event.stopPropagation();
    setActivePopup(-1);
    const onConfirm = async () => {
      try {
        await dispatch(Ai.actions.createCustomTemplate({
          name: template.name + ' copy',
          project_id: projectId,
          description: template.description,
          container_image: template.container_images,
          tags: template.tags,
          container_port: template.container_port,
          container_args: template.container_args,
          env_vars: template.env_vars,
          icon_url: template.icon_url,
        }))
        await dispatch(Ai.actions.fetchCustomTemplates(projectId, 1, 8));
        toast.success(`Template ${template.name} copy has been created.`)
      } catch (e) {
        toast.error(`Oops, something went wrong. Error: ${e.message}`)
      }
    }
    dispatch(UIState.actions.showModal(ModalTypes.CONFIRM, {
      title: `Duplicate custom template`,
      message: `Do you want to duplicate the ${template.name} template?`,
      confirmLabel: `Duplicate`,
      cancelLabel: `Close`,
      onConfirm
    }))
  }

  const handleTempPageChange = pageNumber => {
    setCrtTmpPage(pageNumber);
    const filter = filterRef.current.value;
    if (!filter && selectedTags.length === 0) {
      dispatch(Ai.actions.fetchstandardTemplates(pageNumber, 9));
      return;
    }
    dispatch(Ai.actions.fetchTemplatesWithFilter(selectedTags, filter, pageNumber, 9))
  }

  const handleCustomTempPageChange = pageNumber => {
    setCrtCtmTmpPage(pageNumber);
    dispatch(Ai.actions.fetchCustomTemplates(projectId, pageNumber, 8));
  }

  const handleEnterKey = (e) => {
    if (e.key === "Enter") {
      fetchTemplateWithFilter();
    }
  }

  const handleRedirct = () => {
    history.push(mergeUrl(Urls.AI_ON_DEMAND_MODEL_APIS, { projectId }));
  }
  const handleToCreateApiKey = () => {
    history.push(mergeUrl(Urls.SETTINGS_PROJECT, { projectId }));
  }

  return (<div className={'AiServicePage'}>
    <div className={'AiServicePage__header'}>
      <div className={'AiServicePage__header--title'}>

        <div className={'AiServicePage__titleWithIcon'}>
          Dedicated Model Launchpad
          <Tooltip tooltip={'Open documentation'}>
            <a href="https://docs.thetatoken.org/docs/serving-generative-ai-models" target='_blank'>
              <QuestionMarkIcon />
            </a>
          </Tooltip>
        </div>
        <div className={'AiServicePage__header--note'}>
          <span className="AiServicePage__header--note-row">
            Need on-demand model APIs? Click&nbsp;
            <span onClick={handleRedirct} className='AiServicePage__header--link'>here</span>
            . To launch models via API, create an API key &nbsp;
            <span onClick={handleToCreateApiKey} className='AiServicePage__header--link'>here</span>, and check the&nbsp;
            <a
              href="https://docs.thetatoken.org/docs/use-edgecloud-api-keys-to-manage-deployments"
              target="_blank" rel="noreferrer" className='learn-more'>
              docs
            </a>.
          </span>
        </div>
      </div>
      <div>
      </div>
    </div>
    <div className={'AiServicePage__content new-deployment'}>
      <AiTabs>
        <AiTab isSelected={(selectedTab === 'create-from-template')}
          onClick={() => {
            setSelectedTab('create-from-template');
          }}>
          {isMobile ? 'Standard Templates' : 'Create from Standard Template'}
        </AiTab>
        <AiTab isSelected={(selectedTab === 'create-from-custom-template')}
          onClick={() => {
            setSelectedTab('create-from-custom-template');
          }}>
          {isMobile ? 'Custom Templates' : 'Create from Custom Template'}
        </AiTab>
      </AiTabs>
      {
        (selectedTab === 'create-from-template') &&
        <>
          {tags.length > 0 && <div className={'AiServicePage__header--tools template'}>
            <div className={'AiServicePage__header--tags'}>
              {tags.map((tagObj, i) => {
                let { tag, count } = tagObj;
                let selected = selectedTags.includes(tag);
                return <Tag name={tag} key={i} number={count}
                  selected={selected}
                  onClick={() => {
                    setSelectedTags(tags => {
                      if (tags.includes(tag)) tags = tags.filter(t => t !== tag);
                      else tags = tags.concat(tag);
                      return tags;
                    })
                  }} />
              })}
              {isMobile && <div className={'AiServicePage__header--search'}>
                <div className={'AiServicePage__header--search-wrap'}>
                  <div onClick={fetchTemplateWithFilter}>
                    <SearchIcon />
                  </div>
                  <input type='text'
                    className={'AiServicePage__header--search-input'}
                    placeholder='Search Model'
                    ref={filterRef}
                    onKeyDown={handleEnterKey} />
                </div>
              </div>}
            </div>
            {!isMobile && <div className={'AiServicePage__header--search'}>
              <div className={'AiServicePage__header--search-wrap'}>
                <div onClick={fetchTemplateWithFilter}>
                  <SearchIcon />
                </div>
                <input type='text'
                  className={'AiServicePage__header--search-input'}
                  placeholder='Search Model'
                  ref={filterRef}
                  onKeyDown={handleEnterKey} />
              </div>
            </div>}
          </div>}
          {standardTemplates.length > 0 && <div className='AiServicePage__tab-content'>
            <div className='ModelExplorerPage__row'>
              {standardTemplates.map((img, i) => {
                const logoName = (img.name || '').toLowerCase().replace('.', ' ').replace(' ', '-');
                return <div className={classNames('ModelExplorerPage__section',
                  { new: img.rank && img.rank < 100, hot: img.rank && img.rank > 99 && img.rank < 200 })}
                  onClick={() => handleOpenModel(img.id)} key={i}>
                  <div className='ModelExplorerPage__section--title'>
                    <div className='ModelExplorerPage__section--name'>{img.name}</div>
                    <div className={`ModelExplorerPage__section--logo ${logoName}`}></div>
                  </div>
                  <div className='ModelExplorerPage__section--tags'>
                    {img.tags.map((tag, i) => {
                      return <Tag name={tag} key={i} />
                    })}
                  </div>
                  <div className='ModelExplorerPage__section--description' title={img.description}>
                    {img.description || "The description."}
                  </div>
                </div>
              })}
              {standardTemplates.length % 3 === 2 && <div className='ModelExplorerPage__section'></div>}
            </div>
            <div className='ModelExplorerPage__pagination'>
              <Pagination
                size={'lg'}
                currentPage={crtTmpPage}
                totalPages={totalTempPages}
                onPageChange={handleTempPageChange} />
            </div>
          </div>}
        </>
      }
      {
        (selectedTab === 'create-from-template') && standardTemplates.length === 0 &&
        <div className='AiServicePage__tab-content'>
          <div className={'EmptyState'}>
            <div className={'EmptyState__title'}>
              No templates found matching your criteria. Please try adjusting your search or tags.
            </div>
          </div>
        </div>
      }
      {
        (selectedTab === 'create-from-custom-template') &&
        <div className='AiServicePage__tab-content'>
          <div className='ModelExplorerPage__row'>
            {customTemplates.map((tmp, i) => {
              let date = new Date(tmp.create_time);
              const formattedDate = date.toLocaleString('en-US', DateOptions);
              return <div className='ModelExplorerPage__section' onClick={() => handleOpenModel(tmp.id)} key={tmp.id}>
                <div className='ModelExplorerPage__section--name custom'>{tmp.name}</div>
                <div className='ModelExplorerPage__section--time'>
                  {formattedDate}
                </div>
                <div className='ModelExplorerPage__section--tags wrap'>
                  {tmp.tags.map((tag, i) => {
                    return <Tag name={tag} key={i} />
                  })}
                </div>
                <div className='ModelExplorerPage__section--description'>
                  {tmp.description || 'Empty custom template description.'}
                </div>
                <div className={'AiServicePageEllipsis ct'} onClick={(event) => handlePopup(event, i)}>
                  <EllipsisIcon />
                </div>
                {activePopup === i &&
                  <div className={'AiServicePageEllipsis__popup ct'} onClick={e => e.stopPropagation()}>
                    <div className={'AiServicePageEllipsis__popup--row'}
                      onClick={(event) => handleEdit(event, tmp)}>Edit
                    </div>
                    <div className={'AiServicePageEllipsis__popup--row'}
                      onClick={(event) => handleDuplicate(event, tmp)}>Duplicate
                    </div>
                    <div className={'AiServicePageEllipsis__popup--row'}
                      onClick={(event) => handleDelete(event, tmp)}>Delete
                    </div>
                  </div>}
              </div>
            })}
            <div className='ModelExplorerPage__section' onClick={handleOpenCustom}>
              <div className='ModelExplorerPage__section--add'>+</div>
            </div>
            {customTemplates.length % 3 === 1 && <div className='ModelExplorerPage__section'></div>}
          </div>
          <div className='ModelExplorerPage__pagination'>
            <Pagination
              size={'lg'}
              currentPage={crtCtmTmpPage}
              totalPages={totalCustomTempPages}
              onPageChange={handleCustomTempPageChange} />
          </div>
        </div>
      }
    </div>
  </div >
  );
}

export default ModelExplorerPage;

const Tag = ({ name, number, onClick, selected = false }) => {
  let cssName = name.toLowerCase();
  if (/^\d/.test(cssName)) {
    cssName = '_' + cssName;
  }

  return <div
    className={`${(number ? 'AiServicePage__header--tag' : "ModelExplorerPage__section--tag")} ${cssName} ${selected ? 'selected' : ''}`}
    onClick={onClick ? onClick : () => { }}>
    {name}{number && ` (${number})`}
  </div>
}